import "./CheckIn.css";
import {useRef, React, useState, useEffect ,useImperativeHandle, forwardRef} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
   IconButton,
  Tooltip,
  Stack,
  Paper,
} from "@mui/material";
import Box from '@mui/material/Box';
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
// import Button from '@mui/material/Button';
// import DialogContentText from '@mui/material/DialogContentText';
import img4 from "../images/Room1.png";
// import ico2 from "../images/ExitIcon.png"
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import HotelInvoice_Pdf from "../reports/HotelInvoice_Pdf";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import FiberNewIcon from "@mui/icons-material/FiberNew";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import {  PictureAsPdf } from "@mui/icons-material";
import { TableRowsSplitIcon } from "lucide-react";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title" // فقط با گرفتن این ID میشه جابجا کرد
      cancel={'[class*="MuiDialogContent-root"]'} // از داخل محتوا نشه کشید
    >
      <Paper {...props} />
    </Draggable>
  );
}
const CheckOut=forwardRef((props,ref)=> {

  const InvoiceRef = useRef(null);
  useEffect(() => {
    getData();
    getRestData();
  }, [])
  let spc = '    ';
  useImperativeHandle(ref, () => ({
    add: sendUpdate,
    invoice: setOpeninvoice,
 //   edit: sendUpdate,
   // del: sendDelete,
  //  new: onNewAgency,

  }));
  const [Pass_FName, setPass_FName] = useState("");
  const [Pass_LName, setPass_LName] = useState("");
  const [Reserv_Price, setReserv_Price] = useState("");
  const [Reserv_prepayment, setReserv_prepayment] = useState("");
  const [Reserv_Discount, setReserv_Discount] = useState("");
  const [Room_Number, setRoom_Number] = useState("");
  const [Pass_No, setPass_No] = useState("");
  const [Advance, setAdvance] = useState("");
  const [Rate, setRate] = useState(0);
  const [MyRest, setMyRest] = useState([]);
  const [Night_No, setNight_No] = useState(0);
  const [Prese_Name,setPrese_Name]=useState("");
    const [Reserv_Other,setReserv_Other]=useState("");
  const [RoomInvoice, setRoomInvoice] = useState(false);
  const [Reserv_CheckOut, setReserv_CheckOut] = useState(false);
  
  const [Reserv_Checkindate, setReserv_Checkindate] = useState(new Date());
  const [Reserv_Checkoutdate, setReserv_Checkoutdate] = useState(new Date());
  const [Reserv_ExtraAmount, setReserv_ExtraAmount] = useState(0);
  const [Reserv_BreakfastAmount, setReserv_BreakfastAmount] = useState(0);
  const [Reserv_Penalty, setReserv_Penalty] = useState(0);
  
  const [Adults_No, setAdults_No] = useState("");
  const [RestTotal, setRestTotal] = useState(0);
  const cellStyle = {
    height: 20,

    "& .MuiTableCell-root": {
      padding: "2px 4px !important",
      height: "20px",
      lineHeight: "20px",
    
  
  }
  };
  const changeReserv_Penalty= (event) => {
    setReserv_Penalty(event.target.value)
   // setReserv_GelPenalty((event.target.value * Reserv_Rate).toFixed(2))
   }
   const changeReserv_BreakfastAmount= (event) => {
    setReserv_BreakfastAmount(event.target.value)
   // setReserv_GelPenalty((event.target.value * Reserv_Rate).toFixed(2))
   }
   
  const getData = async () => {
    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, true);

    let parsed = JSON.parse(res);

    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setPass_FName(newData[0].Pass_FName)
      setPass_LName(newData[0].Pass_LName)
      setReserv_Price(newData[0].Reserv_Price)
      setReserv_prepayment(newData[0].Reserv_prepayment)
      setAdvance(newData[0].Reserv_Account)
      setReserv_Checkindate(newData[0].Reserv_Checkindate)
      setReserv_Checkoutdate(newData[0].Reserv_Checkoutdate)
      setNight_No(newData[0].Night_No)
      setReserv_ExtraAmount(newData[0].Reserv_ExtraAmount)
      setReserv_BreakfastAmount(newData[0].Reserv_BreakfastAmount)
      setPass_No(newData[0].Pass_No)
      setRoom_Number(newData[0].Room_Number)
      setAdults_No(newData[0].Adults_No)
      setPrese_Name(newData[0].Prese_Name)
      setReserv_Other(newData[0].Reserv_Other)
      setReserv_Discount(newData[0].Reserv_Discount)
      setRate(newData[0].Reserv_Rate)
      setReserv_Penalty(newData[0].Reserv_Penalty)
      setReserv_CheckOut(newData[0].Reserv_CheckOut)
    }
  }
  const getRestData = async () => {
    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
    console.log(localStorage.getItem('Reserv_Id'))
    let res = await GetDataPromise(`${apiMain}/api/v1/restaurant/selectrestaurant?${uparams}`, false);

    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setMyRest(newData)
      let Total = 0;
      newData.map((row) => (
        Total = Total + row.Resturant_Pay
      ))
      setRestTotal(Total)
    }
  }
  const sendUpdate = async (e) => {
    // e.preventDefault()

    let formdata = new FormData();
    let formuser =new FormData();
    formdata.append("Reserv_Id", props.Reserv_Id);
    formdata.append("Reserv_Rate", Rate);
    formdata.append("Reserv_Type", 3);
    formdata.append("Reserv_CheckOut",Reserv_CheckOut ?1 :0);
    // console.log("Reserv_Id", props.Reserv_Id);
    // console.log("Reserv_Rate", Rate);
  //  console.log("Reserv_CheckOut=",Reserv_CheckOut);
    let response;
     // update

       
           response = await PostDataPromise(apiMain + "/api/v1/reservation/updatecheckoutrate", formdata);
          //  let parsed = JSON.parse(response);
           formuser.append("U_id",localStorage.getItem('U_id') );
           formuser.append("Object_Id",3);
           formuser.append("Room_Number", localStorage.getItem("Room_Number"));
             formuser.append("U_Action",'Edit');
            formuser.append("Reserv_Id", props.Reserv_Id);

      response = await PostDataPromise(apiMain + "/api/v1/usercontrol/insert", formuser);
      // let p = props.getDataCard();
    alert('Information saved.')

  }
  function setcloseinvoice(e) {
    setRoomInvoice(e)
  };
  function setOpeninvoice(e) {
    setRoomInvoice(true)
  };
  const SetInvoice = () => {
    return (
      // <Dialog
      //   open={RoomInvoice}
      //   onClose={() => setcloseinvoice(false)}
      //   PaperProps={{
      //     sx: {
      //       maxWidth: 700,
      //       maxHeight: 650,
      //       width: 950,
      //       height: 900,
      //       backgroundColor: '#F2F2F2'
      //     },
      //     component: 'form',
      //     onSubmit: (event) => {
      //       event.preventDefault();
      //       // ZanNumb(false);
      //     },
      //   }}
      // >
      //   <DialogTitle>Invoice</DialogTitle>
      //   <DialogContent>
      //     <DialogContentText>

      //     </DialogContentText>
      //     <HotelInvoice_Pdf
      //       Room_No={props.Room_No}
      //       MyRest={MyRest}
      //       Pass_FName={Pass_FName}
      //       Pass_LName={Pass_LName}
      //       Reserv_Price={Reserv_Price}
      //       Reserv_prepayment={Reserv_prepayment}
      //       Reserv_Account={Advance}
      //       Checkindate={Reserv_Checkindate}
      //       Checkoutdate={Reserv_Checkoutdate}
      //       Night_No={Night_No}
      //       Reserv_Extrabed={Reserv_ExtraAmount}
      //       Reserv_Breakfast={Reserv_BreakfastAmount}
      //       Pass_No={Pass_No}
      //       Room_Number={Room_Number}
      //       Adults_No={Adults_No}
      //       Rate={Rate}
      //       Prese_Name={Prese_Name}
      //          />

      //   </DialogContent>
      //   <DialogActions    >
      //     <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
      //       <Chip label="Exit" color="primary" onClick={() => setcloseinvoice(false)} sx={{ width: 150, cursor: 'pointer' }} />
      //     </Stack>


      //   </DialogActions>
      // </Dialog>

<Dialog
open={RoomInvoice}
onClose={(event, reason) => {
  if (reason === "backdropClick") return;
  setcloseinvoice(false)
}}
PaperComponent={PaperComponent}
PaperProps={{
  sx: {
    maxWidth: 700,
    maxHeight: 450,
    width: 700,
    height: 450,
    backgroundColor: "#F2F2F2",
  },
}}
>
{/* 🔹 Header قابل جابه‌جایی */}
<DialogTitle
  id="draggable-dialog-title"
  sx={{
    cursor: "move",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1,
    borderBottom: "1px solid #ddd",
    bgcolor: "#fafafa",
  }}
>
  {/* 👈 سمت چپ: دکمه‌های اکشن */}
  <Stack direction="row" spacing={1} alignItems="center">
    {/* <Tooltip title="New" arrow>
      <IconButton color="primary" onClick={() => presentsRef.current?.new()}>
        <FiberNewIcon />
      </IconButton>
    </Tooltip> */}

    {/* <Tooltip title="Add" arrow>
      <IconButton color="primary" onClick={() => presentsRef.current?.add()}>
        <AddIcon />
      </IconButton>
    </Tooltip> */}
{/* 
    <Tooltip title="Edit" arrow>
      <IconButton color="primary" onClick={() => presentsRef.current?.edit()}>
        <EditIcon />
      </IconButton>
    </Tooltip> */}

    <Tooltip title="Print" arrow>
      <IconButton color="error" onClick={() => InvoiceRef.current?.pdf()}>
        <PictureAsPdf />
      </IconButton>
    </Tooltip>
  </Stack>

  {/* 🟢 وسط: عنوان دیالوگ */}
  <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
    <span style={{ fontWeight: 600, fontSize: "1rem" }}>Invoice</span>
  </Box>

  {/* 👉 سمت راست: دکمه خروج */}
  <Tooltip title="Exit" arrow>
    <IconButton color="error" onClick={() => setcloseinvoice(false)}>
      <CloseIcon />
    </IconButton>
  </Tooltip>
</DialogTitle>

{/* 📦 محتوا */}
<DialogContent sx={{ p: 2 }}>
<HotelInvoice_Pdf
            ref={InvoiceRef}
            Room_No={props.Room_No}
            MyRest={MyRest}
            Pass_FName={Pass_FName}
            Pass_LName={Pass_LName}
            Reserv_Price={Reserv_Price}
            Reserv_prepayment={Reserv_prepayment}
            Reserv_Advance={Advance}
            Checkindate={Reserv_Checkindate}
            Checkoutdate={Reserv_Checkoutdate}
            Night_No={Night_No}
            Reserv_Extrabed={Reserv_ExtraAmount}
            Reserv_Breakfast={Reserv_BreakfastAmount}
            Pass_No={Pass_No}
            Room_Number={Room_Number}
            Adults_No={Adults_No}
            Rate={Rate}
            Prese_Name={Prese_Name}
            Reserv_BreakfastAmount={Reserv_BreakfastAmount}
            Reserv_ExtraAmount={Reserv_ExtraAmount}
            Reserv_Discount={Reserv_Discount}
                          />

</DialogContent>
</Dialog>
    )
  }
  // function handleClosecheckout() {
  //   props.ChangeXpage(0)
  // }
  // let azdate=Reserv_Checkindate.toString;

  var azdate = new Date(Reserv_Checkindate);
  var tadate = new Date(Reserv_Checkoutdate);

  // var azdate = str.substring(0, 4); // output is Hello
  return (
    <>
      <Box className="CheckIn" style={{ marginTop: '5px', textAlign: 'left', width: '845px', height: '60px', marginLeft: '5px' }}
        component="form"
        sx={{ '& > :not(style)': { m: 1 } }}
        noValidate
        autoComplete="off"
      >
        {/* <div style={{ float: 'right' }}>
          <img onClick={() => handleClosecheckout()} src={ico2} alt={"/"} style={{ width: '30px', height: '30px', cursor: 'pointer' }} />

        </div> */}
        <div style={{ float: 'left', paddingTop: '10px',marginTop:'-10px' }}>

          <svg width="60" height="60" viewBox="0 0 161 161" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="80.0977" cy="80.0977" r="69.7625" fill="#EDD682">
              <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"
              /> </circle>
            <path d="M103.02 52.8957H99.4139V50.7576H99.9351C100.991 50.7576 101.781 49.7845 101.559 48.7496L101.031 46.2817L101.031 46.2808C100.868 45.5203 100.185 44.968 99.407 44.968H97.7012C96.9226 44.968 96.2397 45.5203 96.077 46.2817L95.5494 48.7487C95.3274 49.7835 96.1157 50.7575 97.1733 50.7575H97.6946V52.8955H93.9505V43.2968C93.9505 41.0127 92.0919 39.1542 89.8079 39.1542H64.9109C62.6268 39.1542 60.7683 41.0127 60.7683 43.2968V52.8957H56.5945V50.7576H57.1158C58.1721 50.7576 58.9618 49.7848 58.7405 48.7496L58.212 46.2817C58.0491 45.5203 57.3662 44.968 56.5877 44.968H54.8824C54.1047 44.968 53.4214 45.5203 53.2582 46.2808L53.2577 46.2817L52.7297 48.7496C52.508 49.7866 53.3 50.7576 54.354 50.7576H54.8752V52.8957H51.2687C50.2685 52.8957 49.4547 53.7091 49.4547 54.7097V59.93C49.4547 60.9307 50.2685 61.744 51.2687 61.744H51.8688V62.8143C51.8688 63.2894 52.2538 63.6738 52.7284 63.6738C53.203 63.6738 53.5879 63.2894 53.5879 62.8143V61.744H58.0015L54.9081 67.3875C54.8266 67.5362 54.8187 67.7145 54.8023 67.8005V74.0555C54.0409 74.3224 53.4902 75.0409 53.4902 75.8926V79.2226C53.4902 80.3004 54.3666 81.1768 55.444 81.1768H98.4778C99.5552 81.1768 100.432 80.3004 100.432 79.2226V75.8926C100.432 75.041 99.8813 74.3227 99.12 74.0555V67.8005C99.1034 67.714 99.0965 67.5375 99.0142 67.3875L95.9204 61.744H100.701V62.8143C100.701 63.2894 101.086 63.6738 101.56 63.6738C102.035 63.6738 102.42 63.2894 102.42 62.8143V61.744H103.02C104.021 61.744 104.835 60.9306 104.835 59.93V54.7097C104.835 53.709 104.021 52.8957 103.02 52.8957ZM97.7013 46.6872H99.36L99.8628 49.0384H97.2438L97.7013 46.6872ZM54.9295 46.6855L56.5307 46.641L57.0439 49.0384H54.4262L54.9295 46.6855ZM58.7912 63.8804H95.1305L96.8085 66.941H57.1132L58.7912 63.8804ZM56.5215 68.6602H97.4008V73.9385H56.5215V68.6602ZM59.7331 62.1613L64.0486 54.2882C64.4739 53.5722 65.2494 53.1289 66.0794 53.1106C66.1922 54.1416 67.0582 54.9497 68.1185 54.9497H73.0384C74.1011 54.9497 74.9685 54.138 75.0782 53.1038H78.8434C78.9531 54.138 79.8205 54.9497 80.8832 54.9497H85.8031C86.8634 54.9497 87.7294 54.1416 87.8422 53.1106C88.6676 53.1289 89.4389 53.568 89.8659 54.2757L94.1887 62.1613H59.7331ZM67.7761 52.8881V51.5996C67.7761 51.4107 67.9298 51.2571 68.1186 51.2571H73.0385C73.2273 51.2571 73.381 51.4107 73.381 51.5996V52.8881C73.381 53.077 73.2273 53.2306 73.0385 53.2306H68.1186C67.9297 53.2306 67.7761 53.077 67.7761 52.8881ZM80.5409 52.8881V51.5996C80.5409 51.4107 80.6946 51.2571 80.8834 51.2571H85.8033C85.9921 51.2571 86.1458 51.4107 86.1458 51.5996V52.8881C86.1458 53.077 85.9921 53.2306 85.8033 53.2306H80.8834C80.6945 53.2306 80.5409 53.077 80.5409 52.8881ZM64.9109 40.8734H89.808C91.1444 40.8734 92.2314 41.9604 92.2314 43.2968V55.0144L91.3657 53.4355C91.3607 53.4262 91.3556 53.4178 91.3506 53.4086C90.6169 52.1757 89.2765 51.407 87.8436 51.3883C87.736 50.352 86.8676 49.538 85.8033 49.538H80.8834C79.8205 49.538 78.9528 50.3501 78.8435 51.3848H75.0784C74.9692 50.3501 74.1015 49.538 73.0385 49.538H68.1186C67.0545 49.538 66.186 50.352 66.0784 51.3883C64.6453 51.407 63.3048 52.176 62.5561 53.4355L62.4874 53.5607V43.2968C62.4875 41.9604 63.5745 40.8734 64.9109 40.8734ZM51.2687 60.025C51.2161 60.025 51.1738 59.9821 51.1738 59.9302V54.7098C51.1738 54.6577 51.2163 54.615 51.2687 54.615H60.2963V57.558L58.944 60.0251H51.2687V60.025ZM98.7129 79.2226C98.7129 79.3519 98.6075 79.4577 98.4778 79.4577H55.444C55.3148 79.4577 55.2094 79.3519 55.2094 79.2226V75.8926C55.2094 75.7634 55.3148 75.6576 55.444 75.6576H98.4778C98.6075 75.6576 98.7129 75.7634 98.7129 75.8926V79.2226ZM103.116 59.93C103.116 59.9821 103.073 60.0249 103.02 60.0249H94.9781L93.9927 58.2274V54.6147H103.02C103.073 54.6147 103.116 54.6576 103.116 54.7095V59.93Z" fill="#2C2C2C" />
            <circle cx="80.0976" cy="80.0976" r="78.5976" stroke="#EDD682" stroke-width="3" />
            <rect x="39.126" y="94.493" width="78.9903" height="25.838" rx="12.919" fill="#2C2C2C" />
            <text x="60.130" y="115.493" fontSize={24} fontWeight={'bold'} fill="white">{props.Room_No}</text>
          </svg>


        </div>
        <div style={{ textAlign: 'left', float: 'left' }}>
          <label style={{ marginLeft: '0px', marginTop: '-30px' ,fontSize:'12px'}}>  Rate :</label>
          <input
          style={{width:'40px'}}
            type="text"
            name="firstname"
            id="firstname"
            value={Rate}
            onChange={(e) =>
              setRate(e.target.value)
            }
            placeholder="Enter First Name"
            required
          />
        </div>
        <div style={{ float: 'left' }}>

          <TableContainer >
            <Table sx={{ minWidth: 200, width: 630, "& .MuiTableCell-root": { fontFamily: "Tahoma, sans-serif" ,fontSize:10}}} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow  >
                  <TableCell style={{ backgroundColor: '#F5F5F5' ,width:'58px'}}>Full Name:</TableCell>
                  <TableCell align="left">{Pass_FName.concat(spc, Pass_LName)}</TableCell>
                  <TableCell component="th" scope="row" style={{ backgroundColor: '#F5F5F5' ,width:'20px'}}>Night</TableCell>
                  <TableCell align="left">{Night_No}</TableCell>
                  <TableCell style={{ backgroundColor: '#F5F5F5',width:'48px' }}>Check In</TableCell>
                  <TableCell align="left">{azdate.getFullYear()}-{azdate.getDate()}-{azdate.getDay() + 1}</TableCell>
                  <TableCell component="th" scope="row" style={{ backgroundColor: '#F5F5F5',width:'56px' }}>Check Out</TableCell>
                  <TableCell align="left">{tadate.getFullYear()}-{tadate.getDate()}-{tadate.getDay() + 1}</TableCell>

                </TableRow>
              </TableHead>
            </Table>

          </TableContainer>
        </div>
      </Box>
      <div style={{ position: 'left' }}>
        <Box className="CheckIn" style={{ width: '243px', height: '390px', marginTop: '10px', marginLeft: '5px' }}
          component="form"
          noValidate
          autoComplete="off"
        >
          <label style={{ fontSize: 14, fontWeight: 'bold', width: '200px', float: 'center' }}> Your Price Summary  $ </label>

          <div style={{ textAlign: 'left' }}>
            <div>
              <TableContainer  >
                <Table sx={{ minWidth: 100, width: 241, "& .MuiTableCell-root": { fontFamily: "Tahoma, sans-serif", fontWeight: 'bold' ,fontSize:10}}} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#F5F5F5' , fontWeight: 'bold' }}>
                      <TableCell >Description</TableCell>
                      <TableCell align="right">$</TableCell>
                      <TableCell align="right">Gel</TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'}} } >
                      <TableCell component="th" scope="row">price Room</TableCell>
                      <TableCell align="right">{((Reserv_Price)*100/100).toFixed(2)}</TableCell>
                      <TableCell align="right">{((Reserv_Price * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'}}} >
                      <TableCell component="th" scope="row">Breakfast</TableCell>
                      <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کوتاه شدن
                }}
                type="text"
                id="Other"
                value={Reserv_BreakfastAmount}
                onChange={changeReserv_BreakfastAmount}
                required
              />
              </TableCell>
                      {/* <TableCell align="right">{Reserv_BreakfastAmount * Adults_No}</TableCell> */}
                      <TableCell align="right">{Reserv_BreakfastAmount *Adults_No * Rate}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'} }} >
                      <TableCell component="th" scope="row">Extra</TableCell>
                      <TableCell align="right">{Reserv_ExtraAmount*Night_No}</TableCell>
                      <TableCell align="right">{Reserv_ExtraAmount * Night_No* Rate}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'} }} >
                      <TableCell component="th" scope="row">Other </TableCell>
                      <TableCell align="right">{Reserv_Other}</TableCell>
                      <TableCell align="right">{Reserv_Other * Rate}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0, fontWeight: 'bold' } }} >
                      <TableCell component="th" scope="row">Resturant </TableCell>
                      <TableCell align="right">{RestTotal}</TableCell>
                      <TableCell align="right">{RestTotal * Rate}</TableCell>
                    </TableRow>
 
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, fontWeight: 'bold', backgroundColor: '#EDD682' }} >
                      <TableCell component="th" scope="row">Total</TableCell>
                      <TableCell align="right"> {((Advance) * 100 / 100).toFixed(2)}</TableCell>
                      <TableCell align="right">{((Advance * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'} }} >
                      <TableCell component="th" scope="row">Discount </TableCell>
                      <TableCell align="right">{((Reserv_Discount + RestTotal)*100/100).toFixed(2)}</TableCell>
                      <TableCell align="right">{(((Reserv_Discount) * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>
                     <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'} }} >
                      <TableCell component="th" scope="row">Prepayment</TableCell>
                      <TableCell align="right">{((Reserv_prepayment)*100/100).toFixed(2)}</TableCell>
      
                      <TableCell align="right">{((Reserv_prepayment * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'} }} >
                      <TableCell component="th" scope="row">Penalty</TableCell>
                      <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کوتاه شدن
                }}
                type="text"
                id="Other"
                value={Reserv_Penalty}
                onChange={changeReserv_Penalty}
                required
              />
            </TableCell>
                      {/* <TableCell align="right">{((Reserv_Penalty)*100/100).toFixed(2)}</TableCell> */}
                      <TableCell align="right">{((Reserv_Penalty * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>  
                     
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'}, backgroundColor: '#EDD682' }} >
                      <TableCell component="th" scope="row">Payable</TableCell>
                      <TableCell align="right">{((Advance-Reserv_prepayment-Reserv_Discount+Reserv_Penalty)*100/100).toFixed(2)}</TableCell>
    
                      <TableCell align="right">{(((Advance-Reserv_prepayment-Reserv_Discount+Reserv_Penalty) * Rate)*100/100).toFixed(2)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <label style={{fontSize:'8px',marginTop:'10px'}}>Check Out</label>
              <input style={{ marginLeft: "30px", width: '30px' }}
                type="checkbox"
                name="Reserv_CheckOut"
                id="Reserv_CheckOut"
                disabled={false}
                value={Reserv_CheckOut}
                checked={Reserv_CheckOut}
                onChange={(e) => {setReserv_CheckOut(e.target.checked);props.ChangeCheckOutflag(e.target.checked)}}
                defaultValue={0}
                //placeholder=""
                required
              />
            </div>
          </div>
        </Box>

        <div style={{ float: 'left', marginTop: '-345px', marginLeft: '290px' }}>

          <Box className="CheckIn" style={{ width: '260px', height: '390px', position: 'left', marginLeft: '5px',marginTop:'-75px' }}
            component="form"
            noValidate

          >
            <label style={{ fontSize: 14, fontWeight: 'bold', width: '100px', float: 'left' }}> Resturant </label>

            <div style={{ float: 'left' }}>

              <div>
                <TableContainer >
                  <Table sx={{ minWidth: 100, width: 280, "& .MuiTableCell-root": { fontFamily: "Tahoma, sans-serif" ,fontSize:10} }} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#F5F5F5', fontWeight: 'bold' }}>
                        <TableCell >Date</TableCell>
                        <TableCell align="right">Description</TableCell>
                        <TableCell align="right">Price&nbsp;($)</TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {MyRest.map((row) => (

                        <TableRow
                          key={row.Id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0, fontWeight: 'bold' } }}
                        >
                          <TableCell align="left" component="th" scope="row">{row.Resturant_Date} </TableCell>
                          <TableCell align="left">{row.Resturant_Desc}</TableCell>
                          <TableCell align="right">{row.Resturant_Pay}</TableCell>

                        </TableRow>

                      )
                      )}
                      <TableRow
                        key={10}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 , fontWeight: 'bold'}, backgroundColor: '#EDD682' }}
                      >
                        <TableCell align="left" component="th" scope="row">Total </TableCell>
                        <TableCell align="left"></TableCell>
                        <TableCell align="right">{RestTotal}</TableCell>

                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

              </div>
            </div>
            <Box className="CheckIn" style={{ marginTop: '-10px', width: '250px', height: '390px', marginLeft: '285px' }}
              component="form"
              noValidate

            >
              <div style={{ float: 'right', marginTop: '-20px' }}>
                <div >
                  <img src={img4} alt={"/"} style={{marginTop:'0px',width:'100%'}} />
                </div>
              </div>
            </Box>
          </Box>
        </div>
      </div>
      {SetInvoice()}
      {/* <div class style={{ float: 'left' }}>
        <Button sx={{ backgroundColor: "#EDD682", color: "black", width: "270px", marginLeft: '10px', marginTop: '-100px', cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }}
          type="submit"
          value="Submit"
          onClick={sendUpdate}
        >
          confirm
        </Button>
        <Button sx={{ backgroundColor: "#2C2C2C", color: '#ffffff', width: "290px", marginLeft: '15px', marginTop: '-100px', transition: '0.7s', ':hover': { backgroundColor: "#EDD682", color: "#000000" } }}
          type="submit"
          value="Submit"
          onClick={() => setRoomInvoice(true)}

        >
          Invoice
        </Button>
      </div> */}


    </>

  );

})
export default CheckOut;